import { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import Loading from 'components/system/Loading';
import { useModalContext } from 'components/system/ModalContext';
import { cardBrandDetails } from 'constants/payments';
import BillingDetailsForm from 'components/pages/Payments/UpdateBillingDetailsForm';
import colors from 'styles/colors';
import DeleteCardDialog from './DeleteCardDialog';

const PaymentMethodCard = ({
  card: {
    brand, expMonth, expYear, last4,
  } = {},
  billingDetails: {
    address: {
      country, state, postalCode,
    },
  } = { address: {} },
  id: paymentMethodId,
}) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const { label, logo: CardLogo } = cardBrandDetails[brand] || {};
  const { openModal, closeModal } = useModalContext();

  const onDeleteHandler = () => {
    setIsDeleting(true);
    closeModal();
  };

  const onSuccessHandler = () => {
    setIsDeleting(false);
  };

  const handleDeleteIconClick = () => {
    openModal({
      content: (
        <DeleteCardDialog
          paymentMethodId={paymentMethodId}
          onCancel={closeModal}
          onClose={onDeleteHandler}
          onSuccess={onSuccessHandler}
        />
      ),
    });
  };
  const handleEditIconClick = () => {
    openModal({
      content: (
        <BillingDetailsForm
          onSuccess={() => closeModal()}
        />
      ),
    });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'top',
        padding: '16px',
        background: colors.background.paper_8p,
        borderRadius: '12px',
        mt: '20px',
        position: 'relative',
      }}
    >
      {
        isDeleting ? <Loading /> : (
          <>
            <CardLogo />
            <Box sx={{ marginLeft: '16px' }}>
              <Typography type="body2" sx={{ color: colors.text.primary }}>
                {label}
                {' '}
                ••••
                {last4}
              </Typography>
              <Typography type="helperText" sx={{ color: colors.text.tetriary, marginBottom: '5px' }}>
                Expiry
                {' '}
                {expMonth}
                /
                {expYear}
              </Typography>
              <Typography type="body2" sx={{ color: colors.text.primary }}>
                Zip Code:
                {' '}
                {postalCode}
                ,
                {' '}
                {country}
                ,
                {' '}
                {state}
                ,
              </Typography>
            </Box>
            <CloseIcon
              fontSize="12px"
              htmlColor={colors.text.primary}
              sx={{
                cursor: 'pointer', position: 'absolute', right: '10px', top: '10px',
              }}
              onClick={handleDeleteIconClick}
            />
            <EditOutlinedIcon
              fontSize="12px"
              htmlColor={colors.text.primary}
              sx={{
                cursor: 'pointer', position: 'absolute', right: '10px', bottom: '10px',
              }}
              onClick={handleEditIconClick}
            />
          </>
        )
      }
    </Box>
  );
};

export default PaymentMethodCard;
